import type { CSSProperties, ReactNode } from 'react';

/**
 * A read-only field that looks like the legacy rep-ui view pages: an MUI
 * `variant='standard'` TextField with `InputProps.readOnly` (fragment/TextField
 * -> palmetto-ui-components NormalTextField). Shrunk 12px label in the default
 * label colour (`--pcl-default-label-color`, rgba(0,0,0,.6)), 16px value in
 * the primary text colour and the 1px underline the read-only input keeps.
 */
export const LEGACY_LABEL_COLOR = 'rgba(0, 0, 0, 0.6)';
export const LEGACY_VALUE_COLOR = 'rgba(0, 0, 0, 0.87)';

const labelStyle: CSSProperties = {
  fontSize: 12,
  lineHeight: 1.33,
  color: LEGACY_LABEL_COLOR,
  fontWeight: 400,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const valueStyle: CSSProperties = {
  marginTop: 8,
  padding: '4px 0 5px',
  minHeight: '1.4375em',
  lineHeight: '1.4375em',
  fontSize: 16,
  color: LEGACY_VALUE_COLOR,
  borderBottom: `1px solid ${LEGACY_LABEL_COLOR}`,
  overflowWrap: 'anywhere',
};

const LegacyField = ({
  label,
  value,
  className,
  style,
}: {
  label: string;
  value?: ReactNode;
  className?: string;
  style?: CSSProperties;
}) => (
  <div
    className={className}
    style={{ display: 'flex', flexDirection: 'column', minHeight: 56, minWidth: 0, ...style }}>
    <span style={labelStyle}>{label}</span>
    <div style={valueStyle}>
      {value === undefined || value === null || value === '' ? ' ' : value}
    </div>
  </div>
);

export default LegacyField;
